import React from 'react';
import { F } from './estilos';

const MAX_EXCLUIDAS = 20;

const textoNivel = (nivel) =>
  `Nivel de mensajería: ${nivel.codigo} (${nivel.limite == null ? 'sin límite' : `${nivel.limite} cada 24 horas`})`;

/** El informe de §3.5: bloqueos, nivel de mensajería, filas y columnas. La muestra va en la vista previa. */
const InformeAnalisis = ({ informe }) => (
  <div style={F.informe} data-testid="informe-analisis">
    {informe.bloqueos.map((b) => <div key={b} style={F.banner('error')}>{b}</div>)}
    {informe.nivelMensajeria?.superado && (
      <div style={F.banner('error')}>
        Las filas válidas superan el nivel de mensajería: la campaña fallará al enviarse.
      </div>
    )}
    {!informe.nivelMensajeria && (
      <div style={F.banner('aviso')}>No se pudo leer el nivel de mensajería: se comprobará al enviar.</div>
    )}
    <div style={F.cifras}>
      <span style={F.cifra}>{`Filas válidas: ${informe.filasValidas}`}</span>
      {informe.filasExcluidas.length > 0 && (
        <span style={F.cifra}>{`Filas excluidas: ${informe.filasExcluidas.length}`}</span>
      )}
      {informe.nivelMensajeria && <span style={F.cifra}>{textoNivel(informe.nivelMensajeria)}</span>}
    </div>
    {informe.msisdnNormalizados > 0 && (
      <p style={F.informeLinea}>{`Se normalizaron ${informe.msisdnNormalizados} msisdn.`}</p>
    )}
    <p style={F.informeLinea}>{`Variables de la plantilla: ${informe.columnasPlantilla.join(', ') || 'ninguna'}`}</p>
    <p style={F.informeLinea}>{`Contexto extra: ${informe.columnasContexto.join(', ') || 'ninguno'}`}</p>
    {informe.filasExcluidas.length > 0 && (
      <details>
        <summary style={{ ...F.informeLinea, cursor: 'pointer', fontWeight: 600 }}>Ver las filas excluidas</summary>
        <ul style={{ margin: '6px 0 0', paddingLeft: 18, fontSize: 13, color: '#4b5563' }}>
          {informe.filasExcluidas.slice(0, MAX_EXCLUIDAS).map((f) => (
            <li key={f.fila}>{`Fila ${f.fila}: ${f.motivo}`}</li>
          ))}
        </ul>
        {informe.filasExcluidas.length > MAX_EXCLUIDAS && (
          <p style={F.informeLinea}>{`… y ${informe.filasExcluidas.length - MAX_EXCLUIDAS} más.`}</p>
        )}
      </details>
    )}
  </div>
);

export default InformeAnalisis;
